import React, { useRef } from 'react'
import { Search, X } from 'lucide-react'
import { Button } from 'components/ui/Button/Button'
import { TextInput, ITextInputProps } from './TextInput'

interface ISearchInputProps extends Omit<ITextInputProps, 'leftIcon' | 'rightIcon'> {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClear?: () => void
  // RTL: search icon moves to the right (reading start), clear moves to the left
  direction?: 'ltr' | 'rtl'
}

export const SearchInput: React.FC<ISearchInputProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search…',
  direction = 'ltr',
  dir,
  textAlign,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const isRtl = direction === 'rtl'

  const handleClear = () => {
    onClear?.()
    inputRef.current?.focus()
  }

  const clearButton = value ? (
    <Button
      variant="icon"
      minW="20px"
      h="20px"
      p="3px"
      borderRadius="4px"
      onClick={handleClear}
      aria-label="clear search"
    >
      <X size={12} />
    </Button>
  ) : undefined

  const searchIcon = <Search size={15} />

  return (
    <TextInput
      ref={inputRef}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      dir={isRtl ? 'rtl' : dir}
      textAlign={isRtl ? 'right' : textAlign}
      leftIcon={isRtl ? clearButton : searchIcon}
      rightIcon={isRtl ? searchIcon : clearButton}
      leftIconClickable={isRtl && Boolean(clearButton)}
      rightIconClickable={!isRtl && Boolean(clearButton)}
      {...rest}
    />
  )
}
